<template>
  <div class="animated fadeIn" id="faturamento-competencia">
    <div class="card card-default">
      <div class="card-header">
        <div class="card-header"><i class="fa fa-money"></i> Orçamento</div>
      </div>
      <div class="card-body">
        <div class="input-group mb-3 d-flex align-items-center">
          <span
            class="input-group-text"
            id="profissional"
            style="width: 80px; height: 40px"
          >
            Sistema
          </span>
          <b-form-group style="margin-bottom: 0; margin-left: 10px">
            <meta-select
              :key="metaSelectKey"
              label=""
              id="meta-select"
              v-model="selectedMeta"
              :options="sistemas"
              select-label="Selecionar"
              deselect-label="Remover"
              attr-label="nome"
              placeholder="Selecione o sistema"
              name="meta-select"
              ref="selectMeta"
            />
          </b-form-group>
          <span
            class="input-group-text"
            id="profissional"
            style="width: 110px; height: 40px; margin-left: 10px"
          >
            Changepoint
          </span>
          <input
            v-model="changepoint"
            type="text"
            style="
              margin-left: 10px;
              border: 1px solid #ced4da;
              border-radius: 0.25rem;
              width: 240px;
              height: 40px;
              padding-left: 12px;
            "
            placeholder="Digite o CE-UM..."
          />

          <button
            class="btn btn-primary search-btn"
            style="margin-left: 10px; height: 36px"
            @click="salvar"
            :disabled="!changepoint || !selectedMeta"
          >
            <i v-if="isGenerating" class="fa fa-spinner fa-spin"></i>
            <span v-else><i class="fa fa-save"></i> Salvar</span>
          </button>
        </div>
      </div>
      <div class="input-group mb-3 d-flex align-items-center">
        <input
          v-model="changepointOrcamento"
          type="text"
          style="
            margin-left: 110px;
            border: 1px solid #ced4da;
            border-radius: 0.25rem;
            width: 225px;
            height: 40px;
            padding-left: 12px;
          "
          placeholder="Digite o CE-UM..."
        />
        <button
          class="btn btn-primary search-btn"
          style="margin-left: 10px; height: 36px"
          :disabled="!changepointOrcamento"
          @click="orcamento"
        >
          Abrir Orçamento
        </button>
      </div>
    </div>
    <div class="card card-default">
      <div class="card-header">
        <div class="card-header">
          <i class="fa fa-money"></i> Horas Alocação
        </div>
      </div>
      <div class="card-body">
        <span>
          <p
            style="
              margin-left: 10px;
              width: 240px;
              padding-left: 12px;
            "
          >
            Ultimo Registro: {{ this.horaAtual }} Horas
          </p>
        </span>
        <input
          v-model="horasAlocacao"
          type="text"
          style="
            margin-left: 10px;
            border: 1px solid #ced4da;
            border-radius: 0.25rem;
            width: 240px;
            height: 40px;
            padding-left: 12px;
          "
          placeholder="Digite a quantidade de horas"
        />
        <button
          class="btn btn-primary search-btn"
          style="margin-left: 10px; height: 36px"
          @click="salvarHorasAlocacao"
          :disabled="!horasAlocacao"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Uteis from "@/mixins/utils.js";
import MetaSelect from "meta-select";

export default {
  components: {
    MetaSelect,
  },
  mixins: [Uteis],
  name: "Orcamento",
  data() {
    return {
      metaSelectKey: 0,
      selectedMeta: "",
      sistemas: [],
      changepoint: "",
      isGenerating: false,
      changepointOrcamento: "",
      horasAlocacao: "",
      horaAtual: "",
    };
  },
  methods: {
    notificar(mensagem, tipo, nivel = "info") {
      this.$bvToast.toast(mensagem, {
        title: tipo,
        variant: nivel,
        solid: true,
      });
    },

    async salvar() {
      this.isGenerating = true;
      try {
        this.changepoint = this.changepoint.replace(/\s+/g, "");
        const demanda = await this.getDemanda(this.changepoint);
        if (demanda.success) {
          return this.notificar("Demanda já existe", "Aviso!", "danger");
        }
        this.postDemanda();
        this.clear();
        return this.notificar("Orçamento Cadastrado", "Sucesso!", "success");
      } catch (error) {
        console.error("Erro ao salvar:", error);
        this.notificar("Ocorreu um erro ao salvar.", "erro", "danger");
      } finally {
        this.isGenerating = false;
      }
    },

    async getSistemas() {
      try {
        const response = await this.$http.get("/orcamentos/sistemas");

        if (response.data.success && Array.isArray(response.data.registros)) {
          this.sistemas = response.data.registros;
        } else {
          console.error("Formato inesperado da resposta:", response.data);
        }
      } catch (error) {
        this.notificar(
          "Ocorreu um erro ao carregar os sistemas.",
          "erro",
          "danger"
        );
      }
    },
    async getDemanda(data) {
      try {
        const response = await this.$http.get("/orcamentos/demanda", {
          params: {
            changepoint: data,
          },
        });
        return response.data;
      } catch (error) {
        console.error("Erro ao obter demanda:", error);
        this.notificar("Ocorreu um erro ao obter a demanda.", "erro", "danger");
      }
    },
    async postDemanda() {
      try {
        const response = await this.$http.post(
          "/orcamentos/cadastro-demanda",
          null,
          {
            params: {
              changepoint: this.changepoint,
              sistema_id: this.selectedMeta.id,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Erro ao salvar demanda:", error);
        this.notificar("Ocorreu um erro ao salvar a demanda.", "erro");
      }
    },
    clear() {
      this.selectedMeta = null;
      this.changepoint = "";
      this.metaSelectKey++;
    },
    async orcamento() {
      this.changepointOrcamento = this.changepointOrcamento.replace(/\s+/g, "");
      const demanda = await this.getDemanda(this.changepointOrcamento);
      if (!demanda.success) {
        return this.notificar("Demanda não existe", "Aviso!", "danger");
      }
      return window.open(
        `http://10.20.0.146:8087/demanda/${this.changepointOrcamento}/orcamento`,
        "_blank"
      );
    },
    async salvarHorasAlocacao() {
      try {
        const valor = parseFloat(String(this.horasAlocacao).replace(",", "."));

        const response = await this.$http.post(
          "/orcamentos/atualizar-horas-alocacao",
          {
            horas: valor,
          }
        );

        if (!response.data.success) {
          this.notificar("Erro ao Alterar Demanda", "Aviso!", "danger");
          return;
        }

        this.notificar("Orçamento Alterada", "Sucesso!", "success");
      } catch (error) {
        console.error("Erro ao salvar horas de alocação:", error);
        this.notificar("Erro na requisição", "Erro!", "danger");
      }
    },

    async getHoras() {
      try {
        const response = await this.$http.get(
          "/orcamentos/hora-alocacao-atual"
        );
        console.log(response);
        this.horaAtual = response.data[0].horas_funcionais;
      } catch (error) {
        console.error("Erro ao salvar horas de alocação:", error);
        this.notificar("Erro na requisição", "Erro!", "danger");
      }
    },
  },
  mounted() {
    this.getSistemas();
    this.getHoras();
  },
};
</script>
